const CashInflowCard = ({data}) => {
  return (
    <div className="p-1 w-full h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-success">
        Financial inflow
      </span>

      <div className="flex-col align-start justify-start g-05">
        <div
          className="flex-row align-center justify-start g-05 pt-1 pb-1"
          style={{ borderBottom: "1.5px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
           {data?.timestamp}
          </span>
        </div>
        <div
          className="flex-row align-center justify-start g-05 pt-1 pb-1"
          style={{ borderBottom: "1.5px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Credited ₹:</span>
          <span className="poppins t-14 color-grayColor">₹ {data?.credited}</span>
        </div>
        <div className="flex-row align-center justify-start g-05 pt-1 pb-1">
          <span className="poppins t-14 color-black">into:</span>
          <span className="poppins t-14 color-grayColor">{data?.into}</span>
        </div>
      </div>
      <button type="button" className="actionBtn w-full">
        View result
      </button>
    </div>
  );
};

export default CashInflowCard;
